// 官网域名：hotel.xinjingtech.net
// 管理平台域名：cloud.hotel.xinjingtech.net
// 内部管理后台： hotel.internal.xinjngtech.com
// 后台预发布环境：pre.xinjngtech.com
// 内部后台预发布环境：pre.internal.xinjngtech.com
// 测试官网域名：test.hotel.xinjingtech.net

let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
switch (domain) {
  case 'hotel.xinjingtech.net':
    base = 'xinjingtech.net' // 正式官网
    break;
  case 'cloud.hotel.xinjingtech.net': // 正式酒店
    base = 'xinjingtech.net'
    break;
  case 'pre.xinjngtech.com': //  酒店预发布环境      
    base = 'xinjngtech.com'
    break;
  case 'test.website.xinjngtech.com':
    base = 'xinjngtech.com' // 测试官网
    break;
  case 'test.xinjngtech.com': // 测试酒店
    base = 'xinjngtech.com'
    break;
  case 'dev.xinjngtech.com': //  酒店本地环境   
    base = 'xinjngtech.com'
    break;
  default:
    if (hotelType) {
      console.log(hotelType, 'url--------')
      base = 'xinjngtech.com'
      //  base = 'https://dev.xinjngtech.com/'
    } else {
      base = process.env.NODE_SHARE_DOMAIN || window.location.host.slice(window.location.host.indexOf('.') + 1, window.location.host.length)
    }
    break;

}
export default base;



// WEBPACK FOOTER //
// ./src/api/domin.js